module.exports = __webpack_public_path__ + "static/media/YF50_0.eb330e62.jpg";